"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InvestorProfilePageOne;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _InvestorProfileWizardFormControls = require("./InvestorProfileWizardFormControls");
var _InvestorProfileWizardCalc = require("./InvestorProfileWizardCalc.config");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function InvestorProfilePageOne() {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    if (values.hasNavigatedPage) {
      document.getElementById(_InvestorProfileWizardCalc.calcName).scrollIntoView();
      /* istanbul ignore else*/
      if (window) {
        window.scrollBy(0, -112);
      }
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_InvestorProfileWizardFormControls.WithdrawPlan, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_InvestorProfileWizardFormControls.RiskTolerance, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_InvestorProfileWizardFormControls.CurrentAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_InvestorProfileWizardFormControls.RetirementAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_InvestorProfileWizardFormControls.LifeExpectancy, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }));
}